import { render, staticRenderFns } from "./fechamentodecaixa.vue?vue&type=template&id=1ceea710&"
import script from "./fechamentodecaixa.vue?vue&type=script&lang=js&"
export * from "./fechamentodecaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports